var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAnteciparParcelasSensia = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 90,
  height: 88,
  viewBox: "0 0 90 88",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M33.7503 58.25H63.1253C64.2024 58.25 65.0837 57.3687 65.0837 56.2917C65.0837 55.2146 64.2024 54.3333 63.1253 54.3333H33.7503C32.6732 54.3333 31.792 55.2146 31.792 56.2917C31.792 57.3687 32.6732 58.25 33.7503 58.25ZM33.7503 48.4583H63.1253C64.2024 48.4583 65.0837 47.5771 65.0837 46.5C65.0837 45.4229 64.2024 44.5417 63.1253 44.5417H33.7503C32.6732 44.5417 31.792 45.4229 31.792 46.5C31.792 47.5771 32.6732 48.4583 33.7503 48.4583ZM43.542 36.7083C43.542 37.7854 44.4232 38.6667 45.5003 38.6667H63.1253C64.2024 38.6667 65.0837 37.7854 65.0837 36.7083C65.0837 35.6313 64.2024 34.75 63.1253 34.75H45.5003C44.4232 34.75 43.542 35.6313 43.542 36.7083Z",
  fill: "#86AA63"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M39.5567 36.1515C39.6727 36.2685 39.6727 36.457 39.5567 36.574L34.355 41.8194C34.2377 41.9377 34.0463 41.9377 33.929 41.8194L32.9131 40.795C32.797 40.6779 32.7972 40.4891 32.9134 40.3722L35.7151 37.5548C35.7778 37.4917 35.7331 37.3843 35.6442 37.3843L27.9448 37.3843C27.8895 37.3843 27.8448 37.4291 27.8448 37.4843L27.8448 58.05C27.8448 58.2157 27.7105 58.35 27.5448 58.35L26.117 58.35C25.9513 58.35 25.817 58.2157 25.817 58.05L25.817 35.6412C25.817 35.4755 25.9513 35.3412 26.117 35.3412L35.6442 35.3412C35.7331 35.3412 35.7778 35.2337 35.7151 35.1707L32.9134 32.3533C32.7972 32.2364 32.797 32.0476 32.9131 31.9305L33.929 30.9061C34.0463 30.7878 34.2377 30.7878 34.355 30.9061L39.5567 36.1515Z",
  fill: "#86AA63",
  stroke: "#86AA63",
  strokeWidth: 0.2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.07004 10.1803C5.44132 10.1803 3.30989 12.1864 3.30989 14.6611L0 83.5197C0 85.9943 2.13143 88 4.76016 88H84.3125C86.9417 88 89.0732 85.9943 89.0732 83.5197L84.816 4.48078C84.816 2.00613 82.6846 -4.54279e-06 80.0554 -4.54279e-06L8.07004 10.1803Z",
  fill: "#162C2B",
  fillOpacity: 0.05
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAnteciparParcelasSensia);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/antecipar_parcelas_sensia.252a5bd46cf0ff141b614e29c82b6f4a.svg";